<div>
  <mat-table #table [dataSource]="paginatedReferences[currentPage - 1]">
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
      <mat-cell *matCellDef="let reference">
        <a *ngIf="reference.name" class="name-link" [attr.href]="reference.name.href" target="_blank" [ngSwitch]="reference.name.type">
          <capra-icon class="name-icon" *ngSwitchCase="'dataset'" class="name-icon" icon="icon-dataset"></capra-icon>
          <capra-icon class="name-icon" *ngSwitchCase="'datasource'" class="name-icon" icon="icon-database"></capra-icon>
          <span
            class="name-text"
            capraTooltip
            tooltipContent="Open Connection settings in new tab"
            [tooltipIsDisabled]="!reference.name.href"
            [tooltipPlacement]="'bottom'"
            [tooltipSize]="'mini'"
          >
            {{reference.name.text}}
          </span>
          <capra-icon *ngIf="reference.name.href" class="link-icon" icon="icon-new-tab"></capra-icon>
        </a>
      </mat-cell>
    </ng-container>

    <!-- Default Access Column -->
    <ng-container matColumnDef="default_access">
      <mat-header-cell *matHeaderCellDef>Default Workspace access</mat-header-cell>
      <mat-cell *matCellDef="let reference" [ngSwitch]="reference.default_access">
        <ng-container *ngSwitchCase="'None'" class="access-text">
          <capra-icon class="access-icon" icon="icon-lock"></capra-icon>
          <span class="access-text">Restricted</span>
        </ng-container>
        <ng-container *ngSwitchCase="'View'" class="access-text">
          <capra-icon class="access-icon" icon="icon-building-view"></capra-icon>
          <span class="access-text">All Members can view</span>
        </ng-container>
        <ng-container *ngSwitchCase="'Query'" class="access-text">
          <capra-icon class="access-icon" icon="icon-building-edit"></capra-icon>
          <span class="access-text">All Members can Query</span>
        </ng-container>
        <span *ngSwitchDefault class="access-text">N/A</span>
      </mat-cell>
    </ng-container>

    <!-- Query Column -->
    <ng-container matColumnDef="query">
      <mat-header-cell *matHeaderCellDef>Referenced by</mat-header-cell>
      <mat-cell *matCellDef="let reference">
        <a *ngIf="reference.query" class="query-link" href="{{reference.query.href}}" target="_blank">
          <span class="query-name-text">{{reference.query.text}}</span>
          <capra-icon class="link-icon" icon="icon-new-tab"></capra-icon>
        </a>
        <span *ngIf="!reference.query" class="query-name-text">N/A</span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let reference; columns: displayedColumns;"></mat-row>
  </mat-table>
  <div class="report-referenced-data-footer">
    <mode-paginator
      class="paginator"
      *ngIf="paginatedReferences?.length > 1"
      [currentPage]="currentPage"
      [numberOfPages]="paginatedReferences.length"
      (pageChangeEvent)="handleChangeCurrentPage($event)"
    ></mode-paginator>
    <span *ngIf="paginatedReferences?.length > 1" class="paginator-page-range">
      {{pageSizeStart}}-{{pageSizeEnd}} of {{references.length}} results
    </span>
  </div>

</div>
